import { sizeQueryOperatorEnum } from '@/global/enum'
import { InputNumber, InputNumberProps, Row, Select, SelectProps } from 'antd'
import { cloneDeep } from 'lodash'
import { CSSProperties, useState, useEffect } from 'react'

export type SizeQueryValueType = {
  operator?: string
  num?: number
}
export type SizeQueryValueFieldName = keyof SizeQueryValueType
// export type SizeQueryValueType = [operator?: string, val?: number]
export interface SizeQueryProps {
  selectProps?: SelectProps
  inputProps?: InputNumberProps
  value?: SizeQueryValueType //
  onChange?: (val: SizeQueryValueType) => void
  style?: CSSProperties
  className?: string
}
const defaultValue: SizeQueryValueType = {}

const SizeQuery: React.FC<SizeQueryProps> = (props: SizeQueryProps) => {
  const {
    selectProps,
    inputProps,
    style,
    className,
    value = defaultValue,
    onChange,
  } = props
  const { options = sizeQueryOperatorEnum } = selectProps || {}
  const { operator, num } = value

  const [innerValue, setInnerValue] = useState<SizeQueryValueType>({})

  const changeInnerValue = (field: SizeQueryValueFieldName, val: any) => {
    const newValue = cloneDeep(innerValue)
    newValue[field] = val
    setInnerValue(newValue)
    onChange?.(newValue)
  }

  useEffect(() => {
    setInnerValue({ operator, num })
  }, [operator, num])

  const parser = (value: string) => {
    return value.replace(/[^\d.-]/g, '')
  }
  return (
    <Row style={style} wrap={false} className={className}>
      <Select
        style={{
          width: 60,
        }}
        {...selectProps}
        value={operator || innerValue.operator}
        options={options}
        placeholder="请选择"
        allowClear
        onChange={(val) => changeInnerValue('operator', val)}
      ></Select>
      <InputNumber
        {...inputProps}
        placeholder="请输入"
        value={num || innerValue?.num}
        onChange={(val) => changeInnerValue('num', val)}
      ></InputNumber>
    </Row>
  )
}

export default SizeQuery
import { sizeQueryOperatorEnum } from '@/global/enum'
import { InputNumber, InputNumberProps, Row, Select, SelectProps } from 'antd'
import { cloneDeep } from 'lodash'
import { CSSProperties, useState, useEffect } from 'react'

export type SizeQueryValueType = {
  operator?: string
  num?: number
}
export type SizeQueryValueFieldName = keyof SizeQueryValueType
// export type SizeQueryValueType = [operator?: string, val?: number]
export interface SizeQueryProps {
  selectProps?: SelectProps
  inputProps?: InputNumberProps
  value?: SizeQueryValueType //
  onChange?: (val: SizeQueryValueType) => void
  style?: CSSProperties
  className?: string
}
const defaultValue: SizeQueryValueType = {}

const SizeQuery: React.FC<SizeQueryProps> = (props: SizeQueryProps) => {
  const {
    selectProps,
    inputProps,
    style,
    className,
    value = defaultValue,
    onChange,
  } = props
  const { options = sizeQueryOperatorEnum } = selectProps || {}
  const { operator, num } = value

  const [innerValue, setInnerValue] = useState<SizeQueryValueType>({})

  const changeInnerValue = (field: SizeQueryValueFieldName, val: any) => {
    const newValue = cloneDeep(innerValue)
    newValue[field] = val
    setInnerValue(newValue)
    onChange?.(newValue)
  }

  useEffect(() => {
    setInnerValue({ operator, num })
  }, [operator, num])

  const parser = (value: string) => {
    return value.replace(/[^\d.-]/g, '')
  }
  return (
    <Row style={style} wrap={false} className={className}>
      <Select
        style={{
          width: 60,
        }}
        {...selectProps}
        value={operator || innerValue.operator}
        options={options}
        placeholder="请选择"
        allowClear
        onChange={(val) => changeInnerValue('operator', val)}
      ></Select>
      <InputNumber
        {...inputProps}
        placeholder="请输入"
        value={num || innerValue?.num}
        onChange={(val) => changeInnerValue('num', val)}
      ></InputNumber>
    </Row>
  )
}

export default SizeQuery
